import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
// import Login from './dashboard/Login';
import Login from './pages/auth/Login';
import UserMain from './dashboard/user/UserMain';
import { ProtectedRoutes } from './dashboard/ProtectedRoutes';
import { useAuth } from './hooks/useAuth';
import ParkMain from './dashboard/park/ParkMain';
import SlotMain from './dashboard/slot/SlotMain';
import ReservationMain from './dashboard/reservation/ReservationMain';
import Profile from './dashboard/app/Profile';
// import Signup from './dashboard/auth/Signup';
import Signup from './pages/auth/Signup';
import PasswordReset from './pages/auth/PasswordReset';
import ForgotPassword from './pages/auth/ForgotPassword';
import Pricing from './pages/landing/Pricing';
import Home from './pages/landing/Home';
import DashboardShell from './pages/app/DashboardShell';
import DashboardTopicIdeasRoute from './pages/app/DashboardTopicIdeasRoute';
import DashboardProjectRoute from './pages/app/DashboardProjectRoute';
import Payments from './pages/app/payments/Payments';
import Account from './pages/app/account/Account';
import GetinTouch from './pages/app/getintouch/GetinTouch';
import Usage from './pages/app/usage/Usage';
import Referrals from './pages/app/referrals/Referrals';
import SiwesReport from './pages/app/siwes/SiwesReport';
import WordEditor from './pages/app/editor/WordEditor';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminDocumentationDetails from './pages/admin/AdminDocumentationDetails';
import AdminReports from './pages/admin/AdminReports';

// Component to redirect authenticated users away from auth pages
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="signup" element={<PublicRoute><Signup/></PublicRoute>} />
      <Route path="login" element={<PublicRoute><Login/></PublicRoute>} />
      <Route path="forgot-password" element={<PublicRoute><ForgotPassword/></PublicRoute>} />
      <Route path="password-reset" element={<PasswordReset/>} />
      <Route path="pricing" element={<Pricing/>} />
      <Route path="admin" element={<AdminLogin/>} />
      <Route path="admin/dashboard" element={<AdminDashboard/>} />
      <Route path="admin/schools" element={<AdminDashboard/>} />
      <Route path="admin/reports" element={<AdminReports/>} />
      <Route path="admin/documentations/:id" element={<AdminDocumentationDetails/>} />
      <Route element={<ProtectedRoutes/>}>
        <Route path="dashboard" element={<DashboardShell />}>
          <Route index element={<Navigate to="topic-ideas" replace />} />
          <Route path="topic-ideas" element={<DashboardTopicIdeasRoute />} />
          <Route path="project/*" element={<DashboardProjectRoute />} />
          <Route path="siwes" element={<SiwesReport />} />
          <Route path="payments" element={<Payments />} />
          <Route path="editor" element={<WordEditor />} />
          <Route path="referrals" element={<Referrals />} />
          <Route path="usage" element={<Usage />} />
          <Route path="get-in-touch" element={<GetinTouch />} />
          <Route path="account" element={<Account />} />
        </Route>
        <Route path="account" element={<Navigate to="/dashboard/account" replace />} />
        <Route path="profile" element={<Profile/>} />
        <Route path="users" element={<UserMain/>} />
        <Route path="parks" element={<ParkMain/>} />
        <Route path="slots" element={<SlotMain/>} />
        <Route path="reservations" element={<ReservationMain/>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
